// Aceleres: classificacao de imagens/videos do chat pelo aspect ratio real
// (naturalWidth / naturalHeight), igual ao WhatsApp — nunca pela altura em
// pixels isolada (uma imagem 1080x1920 tem >344px de altura mas ainda e uma
// proporcao valida). Compartilhado entre Image.vue e Video.vue para as duas
// midias terem exatamente o mesmo comportamento.

export const MEDIA_ASPECT_CLASS = {
  VERY_HORIZONTAL: 'very-horizontal',
  HORIZONTAL: 'horizontal',
  SQUARE: 'square',
  VERTICAL: 'vertical',
  VERY_VERTICAL: 'very-vertical',
};

const MAX_WIDTH = 420;
const VERY_HORIZONTAL_HEIGHT = 190;
const VERY_VERTICAL_WIDTH = 260;
const VERY_VERTICAL_HEIGHT = 400;

export function classifyMediaAspectRatio(ratio) {
  if (!Number.isFinite(ratio) || ratio <= 0) return null;
  if (ratio >= 1.8) return MEDIA_ASPECT_CLASS.VERY_HORIZONTAL;
  if (ratio > 1.1) return MEDIA_ASPECT_CLASS.HORIZONTAL;
  if (ratio >= 0.85) return MEDIA_ASPECT_CLASS.SQUARE;
  if (ratio >= 0.55) return MEDIA_ASPECT_CLASS.VERTICAL;
  return MEDIA_ASPECT_CLASS.VERY_VERTICAL;
}

// Caixa (frame) que envolve a midia. Horizontal/quadrado/vertical normal
// nunca sao ampliados nem cortados — so ganham um teto de largura/altura e
// encolhem pra caber (contain). So os dois extremos ganham uma caixa fixa
// com object-fit: cover, pra evitar bolhas absurdamente finas ou altas.
export function mediaFrameStyle(aspectClass) {
  if (aspectClass === MEDIA_ASPECT_CLASS.VERY_VERTICAL) {
    return { width: `${VERY_VERTICAL_WIDTH}px`, height: `${VERY_VERTICAL_HEIGHT}px` };
  }

  if (aspectClass === MEDIA_ASPECT_CLASS.VERY_HORIZONTAL) {
    return { width: `${MAX_WIDTH}px`, height: `${VERY_HORIZONTAL_HEIGHT}px` };
  }

  return { width: 'fit-content' };
}

// Classe do <img>/<video> dentro do frame: cover nos extremos (a caixa e
// fixa, precisa preencher e centralizar), contain nos demais (nunca corta
// nem deforma, so limita o tamanho maximo).
export function mediaAssetClass(aspectClass) {
  if (
    aspectClass === MEDIA_ASPECT_CLASS.VERY_VERTICAL ||
    aspectClass === MEDIA_ASPECT_CLASS.VERY_HORIZONTAL
  ) {
    return 'h-full w-full object-cover';
  }

  // Classes literais (nao interpoladas) de proposito: o Tailwind precisa
  // encontrar o texto exato "max-w-[420px]"/"max-h-[344px]" no codigo-fonte
  // pra gerar o CSS — uma string montada em runtime nao seria detectada.
  return 'h-auto w-auto max-w-[420px] max-h-[344px] object-contain';
}
